// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"496366c0","470":"b515665e"}[chunkId] + ".chunk.css";
};